import '@/assets/styles/index.css';

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

const app = createApp(App);

app.use(store);

app.use(router).mount('#app');

// eslint-disable-next-line no-console
console.log('Hello 💯');
// eslint-disable-next-line no-console
console.log('v43');
